import React, { useState, useEffect, Fragment } from 'react';
import { ReembolsoSevices } from "../../Services/";
import LoaderScreen from '../layout/LoaderScreen';
import { useTranslation } from 'react-i18next';
import toast from 'react-hot-toast';

const Paso2 = (props) => {
    const { t } = useTranslation();
    const [ActivarLoader, setActivarLoader] = useState(false);
    const [MensajeLoader, setMensajeLoader] = useState("");

    const [FormaDepago, setFormaDepago] = useState([]);
    const [Origenes, setOrigenes] = useState([]);
    const [Destinos, setDestinos] = useState([]);
    const [Monedas, setMonedas] = useState([]);
    const [TipoPasajeros, setTipoPasajeros] = useState([]);
    const [Paises, setPaises] = useState([]);
    const [DocumentoPorPais, setDocumentoPorPais] = useState([]);
    const [PoseeBoleto, setPoseeBoleto] = useState(false);

    const [ErrorEmailMsg, setErrorEmailMsg] = useState("");
    const [ErrorNombresMsg, setErrorNombresMsg] = useState("");
    const [ErrorApellidosMsg, setErrorApellidosMsg] = useState("");
    const [ErrorOrigensMsg, setErrorOrigensMsg] = useState("");
    const [ErrorDestinoMsg, setErrorDestinoMsg] = useState("");
    const [ErrorTipoPasajeroMsg, setErrorTipoPasajeroMsg] = useState("");
    const [ErrorMonedaMsg, setErrorMonedaMsg] = useState("");
    const [ErrorFormaPagoMsg, setErrorFormaPagoMsg] = useState("");

    const [Correo, setCorreo] = useState("");
    const [FormaPago, setFormaPago] = useState("");
    const [Nombres, setNombres] = useState("");
    const [Apellidos, setApellidos] = useState("");
    const [DocumentoReceptor, setDocumentoReceptor] = useState("");
    const [OrigenSelecionado, setOrigenSelecionado] = useState("");
    const [DestinoSelecionado, setDestinoSelecionado] = useState("");
    const [TipoPasajeroSelecionado, setTipoPasajeroSelecionado] = useState("");
    const [MonedaSeleccionado, setMonedaSeleccionado] = useState("");
    const [TipoDocumento, setTipoDocumento] = useState("");
    const [PaisOrigen, setPaisOrigen] = useState("");

    function validarCorreo(inputtxt) {
        try {
            var numbers = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
            return !!inputtxt.match(numbers);
        } catch (ex) {
            return false;
        }
    }
    
    function solotexto(inputtxt) {
        var letters = /^[A-Za-z ]+$/;
        return !!inputtxt.match(letters);
    }

    async function ObtenerOrigenes() {
        try {
            const peticion = await ReembolsoSevices.ObtenerOrigenes();
            if (peticion.status === 200 && peticion.resp != null) {
                setOrigenes(peticion.resp);
            } else {
                toast.error(t('paso2.errorOrigenes', 'Ocurrió un error al cargar los orígenes.'));
            }
        } catch (error) {
            toast.error(t('paso2.errorRed', 'Error de conexión'));
        }
    }

    function LimpiarLocalStorage() {
        window.localStorage.setItem("Paso2", btoa(false));
        window.localStorage.removeItem("Paso3", btoa(false));
        window.localStorage.removeItem("Paso4", btoa(false));
    }

    async function ObtenerDocumentosPorPais(Pais) {
        if (Pais) {
            setActivarLoader(true);
            setMensajeLoader(t('comunes.espere', "Por favor espere..."));
            try {
                const peticion = await ReembolsoSevices.ObtenerDocumentosPorPaises(Pais);
                if (peticion.status === 200 && peticion.resp != null) {
                    setDocumentoPorPais(peticion.resp);
                }
            } catch (error) {
                toast.error(t('paso2.errorDocumentos', 'Ocurrió un error al cargar los documentos.'));
            } finally {
                setActivarLoader(false);
            }
        }
    }

    async function ObtenerPaises() {
        try {
            const peticion = await ReembolsoSevices.ObtenerPaises();
            if (peticion.status === 200 && peticion.resp != null) {
                setPaises(peticion.resp);
            } else {
                toast.error(t('paso2.errorPaises', 'Ocurrió un error al cargar la lista de países.'));
            }
        } catch (error) {
            toast.error(t('paso2.errorRed', 'Error de conexión'));
        }
    }

    async function ObtenerPasajeros() {
        try {
            const peticion = await ReembolsoSevices.ObtenerTipoPasajero();
            if (peticion.status === 200 && peticion.resp != null) {
                setTipoPasajeros(peticion.resp);
            } else {
                toast.error(t('paso2.errorPasajeros', 'Ocurrió un error al cargar los tipos de pasajero.'));
            }
        } catch (error) {
            toast.error(t('paso2.errorRed', 'Error de conexión'));
        }
    }

    async function ObtenerMoneda() {
        try {
            const peticion = await ReembolsoSevices.ObtenerMonedas();
            if (peticion.status === 200 && peticion.resp != null) {
                setMonedas(peticion.resp);
            } else {
                toast.error(t('paso2.errorMonedas', 'Ocurrió un error al cargar las monedas.'));
            }
        } catch (error) {
            toast.error(t('paso2.errorRed', 'Error de conexión'));
        } finally {
            setActivarLoader(false);
        }
    }

    async function ObtenerFormaDePago() {
        setActivarLoader(true);
        setMensajeLoader(t('comunes.espere', "Por favor espere..."));
        var poseBoletoParam = window.localStorage.getItem("PoseeBoleto");
        var Moneda = window.localStorage.getItem("Moneda");
        try {
            const peticion = await ReembolsoSevices.ObtenerFormaPago(Moneda, poseBoletoParam);
            if (peticion.status === 200 && peticion.resp != null) {
                setFormaDepago(peticion.resp);
            } else {
                toast.error(t('paso2.errorFormaPago', 'Ocurrió un error al cargar las formas de pago.'));
            }
        } catch (error) {
            toast.error(t('paso2.errorRed', 'Error de conexión'));
        } finally {
            setActivarLoader(false);
        }
    }

    async function ObtenerDestino(params) {
        if (params !== "") {
            setDestinos([]);
            setDestinoSelecionado("");
            setActivarLoader(true);
            setMensajeLoader(t('paso2.obteniendoDestinos', "Obteniendo destinos..."));
            setOrigenSelecionado(params);
            window.localStorage.setItem("Origen", params);
            setErrorOrigensMsg("");
            try {
                const peticion = await ReembolsoSevices.ObtenerDestino(params);
                if (peticion.status === 200 && peticion.resp != null) {
                    setDestinos(peticion.resp);
                } else {
                    setErrorDestinoMsg(t('paso2.errDestinos', "- Error en destinos."));
                }
            } catch (error) {
                toast.error(t('paso2.errorRed', 'Error de conexión'));
            } finally {
                setActivarLoader(false);
            }
        } else {
            setDestinos([]);
            setOrigenSelecionado("");
            window.localStorage.removeItem("Origen");
            window.localStorage.removeItem("Destino");
            setDestinoSelecionado("");
            setErrorOrigensMsg(t('validaciones.campoObligatorio', "- Campo obligatorio"));
        }
    }

    function asignarDestino(params) {
        if (params !== "") {
            window.localStorage.setItem("Destino", params);
            setDestinoSelecionado(params);
            setErrorDestinoMsg("");
        } else {
            window.localStorage.removeItem("Destino");
            setDestinoSelecionado("");
            setErrorDestinoMsg(t('validaciones.campoObligatorio', "- Campo obligatorio"));
        }
    }

    function ValidarPoseeBoleto() {
        var PoseBoletos = window.localStorage.getItem("PoseeBoleto");
        if (PoseBoletos === "T") {
            setPoseeBoleto(true);
        }
    }

    function asignarDocumentoReceptor(params) {
        if (params !== "") {
            if (params.length <= 20) {
                window.localStorage.setItem("PasajeroDocumento", params);
                setDocumentoReceptor(params);
                CamposObligatoriosCorrectos();
            }
        } else {
            setDocumentoReceptor("");
            window.localStorage.removeItem("PasajeroDocumento");
        }
    }

    function AsignarTipoDocumento(params) {
        setTipoDocumento(params);
        if (params !== "") {
            window.localStorage.setItem("PasajeroTipoDocumentoSolicitante", params);
            CamposObligatoriosCorrectos();
        } else {
            window.localStorage.removeItem("PasajeroTipoDocumentoSolicitante");
        }
    }

    function AsignarPaisOrigen(params) {
        setPaisOrigen(params);
        if (params !== "") {
            setDocumentoPorPais([]);
            ObtenerDocumentosPorPais(params);
            window.localStorage.setItem("PasajeroPaisDocumento", params);
            CamposObligatoriosCorrectos();
        } else {
            window.localStorage.removeItem("PasajeroPaisDocumento");
            window.localStorage.removeItem("PasajeroTipoDocumentoSolicitante");
            setDocumentoPorPais([]);
        }
    }

    function asignarCorreo(params) {
        setCorreo(params);
        if (params !== "") {
            if (validarCorreo(params)) {
                window.localStorage.setItem("Correo", params);
                setErrorEmailMsg("");
                CamposObligatoriosCorrectos();
            } else {
                setErrorEmailMsg(t('validaciones.correoInvalido', "Formato de correo erróneo"));
                window.localStorage.removeItem("Correo");
                CamposObligatoriosCorrectos();
            }
        } else {
            setErrorEmailMsg("");
            window.localStorage.removeItem("Correo");
        }
    }

    function asignarFormaPago(params) {
        if (params !== "") {
            window.localStorage.setItem("FormaPago", params);
            setFormaPago(params);
            setErrorFormaPagoMsg("");
            CamposObligatoriosCorrectos();
        } else {
            window.localStorage.removeItem("FormaPago");
            setFormaPago("");
            setErrorFormaPagoMsg(t('validaciones.campoObligatorio', "- Campo obligatorio"));
            CamposObligatoriosCorrectos();
        }
    }

    function asignarNombres(params) {
        if (params !== "") {
            setErrorNombresMsg("");
            if (solotexto(params)) {
                if (params.length <= 50) {
                    window.localStorage.setItem("Nombres", params);
                    setNombres(params);
                }
            } else {
                setErrorNombresMsg(t('validaciones.soloTexto', "Debe ingresar solo texto"));
            }
        } else {
            setNombres("");
            window.localStorage.removeItem("Nombres");
            setErrorNombresMsg(t('validaciones.campoObligatorio', "- Campo obligatorio"));
        }
        CamposObligatoriosCorrectos();
    }

    function asignarApellidos(params) {
        if (params !== "") {
            setErrorApellidosMsg("");
            if (solotexto(params)) {
                if (params.length <= 50) {
                    window.localStorage.setItem("Apellidos", params);
                    setApellidos(params);
                }
            } else {
                setErrorApellidosMsg(t('validaciones.soloTexto', "Debe ingresar solo texto"));
            }
        } else {
            setApellidos("");
            setErrorApellidosMsg(t('validaciones.campoObligatorio', "- Campo obligatorio"));
            window.localStorage.removeItem("Apellidos");
        }
        CamposObligatoriosCorrectos();
    }

    function asignarTipoPasajero(params) {
        if (params !== "") {
            window.localStorage.setItem("TipoPasajero", params);
            setTipoPasajeroSelecionado(params);
            setErrorTipoPasajeroMsg("");
        } else {
            window.localStorage.removeItem("TipoPasajero");
            setErrorTipoPasajeroMsg(t('validaciones.campoObligatorio', "- Campo obligatorio"));
        }
        CamposObligatoriosCorrectos();
    }

    function asignarMoneda(params) {
        if (params !== "") {
            window.localStorage.setItem("Moneda", params);
            setMonedaSeleccionado(params);
            setFormaDepago([]);
            setFormaPago("");
            ObtenerFormaDePago();
            setErrorMonedaMsg("");
        } else {
            window.localStorage.removeItem("Moneda");
            setMonedaSeleccionado("");
            window.localStorage.removeItem("FormaPago");
            setFormaPago("");
            setFormaDepago([]);
            setErrorMonedaMsg(t('validaciones.campoObligatorio', "- Campo obligatorio"));
        }
        CamposObligatoriosCorrectos();
    }

    function CamposObligatoriosCorrectos() {
        var PoseBoletos = window.localStorage.getItem("PoseeBoleto");
        var Paso1Validado = window.localStorage.getItem("Paso1");
        switch (PoseBoletos) {
            case "S":
                if (Paso1Validado === btoa(true)) {
                    var Correo = window.localStorage.getItem("Correo");
                    var FormaPago = window.localStorage.getItem("FormaPago");
                    if (Correo != null && FormaPago != null) {
                        window.localStorage.setItem("Paso2", btoa(true));
                    } else {
                        window.localStorage.setItem("Paso2", btoa(false));
                    }
                }
                break;
            case "T":
                if (Paso1Validado === btoa(true)) {
                    var Nombres = window.localStorage.getItem("Nombres");
                    var Apellidos = window.localStorage.getItem("Apellidos");
                    var FormaPagoF = window.localStorage.getItem("FormaPago");
                    var CorreoF = window.localStorage.getItem("Correo");
                    var Origen = window.localStorage.getItem("Origen");
                    var Destino = window.localStorage.getItem("Destino");
                    var PasajeroPaisDocumento = window.localStorage.getItem("PasajeroPaisDocumento");
                    var PasajeroTipoDocumentoSolicitante = window.localStorage.getItem("PasajeroTipoDocumentoSolicitante");
                    var PasajeroDocumento = window.localStorage.getItem("PasajeroDocumento");

                    if (Nombres != null && Apellidos != null && FormaPagoF != null && CorreoF != null && Origen != null && Destino != null && PasajeroPaisDocumento != null && PasajeroTipoDocumentoSolicitante != null && PasajeroDocumento != null) {
                        window.localStorage.setItem("Paso2", btoa(true));
                    } else {
                        window.localStorage.setItem("Paso2", btoa(false));
                    }
                }
                break;
            default:
                window.localStorage.setItem("PoseeBoleto", false);
                break;
        }
    }

    useEffect(() => {
        var PoseBoletos = window.localStorage.getItem("PoseeBoleto");
        if (PoseBoletos === "T") {
            ValidarPoseeBoleto();
            setActivarLoader(true);
            setMensajeLoader(t('paso2.obteniendoDatos', "Obteniendo datos del vuelo y pago..."));
            ObtenerOrigenes();
            ObtenerPasajeros();
            ObtenerMoneda();
            ObtenerPaises();
        } else {
            ValidarPoseeBoleto();
            setActivarLoader(true);
            setMensajeLoader(t('paso2.obteniendoMonedas', "Obteniendo monedas..."));
            ObtenerMoneda();
        }
        LimpiarLocalStorage();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            <LoaderScreen props={ActivarLoader} mensaje={MensajeLoader} />
            <div className="_pt-30 container-fluid px-0">
                <div className="theme-page-section-header _ta-l">
                    <h5 className="theme-page-section-title">{t('paso2.titulo', 'Datos del Ticket / Boleto')}</h5>
                    <h5 className="feature-subtitle _op-06">{t('paso2.subtitulo', 'Todos los campos habilitados y marcados con asteriscos (*) son obligatorios.')}</h5>
                    <hr className="style-3" />
                </div>
                <div className="row mt-4">
                    {PoseeBoleto && (
                        <>
                            <div className="col-12 col-md-6 mb-3">
                                <h5 className="_c-dark"><span className="_c-p">*</span> {t('paso2.nombre', 'Nombre(s) del pasajero')} <span className="_c-p">{ErrorNombresMsg}</span></h5>
                                <div className="theme-payment-page-form-item form-group">
                                    <input
                                        value={Nombres}
                                        onChange={(ev) => asignarNombres(ev.target.value)}
                                        className="form-control w-100"
                                        type="text"
                                        placeholder={t('paso2.placeholderNombre', 'Nombre(s)')}
                                    />
                                </div>
                            </div>
                            <div className="col-12 col-md-6 mb-3">
                                <h5 className="_c-dark"><span className="_c-p">*</span> {t('paso2.apellido', 'Apellido(s) del pasajero')} <span className="_c-p">{ErrorApellidosMsg}</span></h5>
                                <div className="theme-payment-page-form-item form-group">
                                    <input
                                        value={Apellidos}
                                        onChange={(ev) => asignarApellidos(ev.target.value)}
                                        className="form-control w-100"
                                        type="text"
                                        placeholder={t('paso2.placeholderApellido', 'Apellido(s)')}
                                    />
                                </div>
                            </div>
                            <div className="col-12 col-md-6 mb-3">
                                <h5 className="_c-dark"><span className="_c-p">*</span> {t('paso2.origen', 'Origen del vuelo')} <span className="_c-p">{ErrorOrigensMsg}</span></h5>
                                <div className="theme-payment-page-form-item form-group">
                                    <i className="fa fa-angle-down"></i>
                                    <select className="form-control seleccionable w-100"
                                        onChange={(ev) => ObtenerDestino(ev.target.value)}
                                        value={OrigenSelecionado}
                                    >
                                        <option value="">{t('comunes.seleccione', 'Seleccione')}</option>
                                        {Object.values(Origenes).map((objeto, index) => (
                                            <option key={`orig-${index}`} value={objeto.ID}>{objeto.Description}</option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                            <div className="col-12 col-md-6 mb-3">
                                <h5 className="_c-dark"><span className="_c-p">*</span> {t('paso2.destino', 'Destino del vuelo')} <span className="_c-p">{ErrorDestinoMsg}</span></h5>
                                <div className="theme-payment-page-form-item form-group">
                                    <i className="fa fa-angle-down"></i>
                                    <select className="form-control seleccionable w-100"
                                        onChange={(ev) => asignarDestino(ev.target.value)} value={DestinoSelecionado}>
                                        <option value="">{t('comunes.seleccione', 'Seleccione')}</option>
                                        {Object.values(Destinos).map((objeto, index) => (
                                            <option key={`dest-${index}`} value={objeto.ID}>{objeto.Description}</option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                            <div className="col-12 col-md-6 mb-3">
                                <h5 className="_c-dark"><span className="_c-p">*</span> {t('paso2.tipoPasajero', 'Tipo de pasajero')} <span className="_c-p">{ErrorTipoPasajeroMsg}</span></h5>
                                <div className="theme-payment-page-form-item form-group">
                                    <i className="fa fa-angle-down"></i>
                                    <select className="form-control seleccionable w-100"
                                        onChange={(ev) => asignarTipoPasajero(ev.target.value)}
                                        value={TipoPasajeroSelecionado}>
                                        <option value="">{t('comunes.seleccione', 'Seleccione')}</option>
                                        {Object.values(TipoPasajeros).map((objeto, index) => (
                                            <option key={`pax-${index}`} value={objeto.ID}>
                                                {t(`backend.tipoPasajeros.${objeto.Description.trim()}`, objeto.Description.trim())}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                        </>
                    )}
                    <div className="col-12 col-md-6 mb-3">
                        <h5 className="_c-dark"><span className="_c-p">*</span> {t('paso2.moneda', 'Moneda de pago original')} <span className="_c-p">{ErrorMonedaMsg}</span></h5>
                        <div className="theme-payment-page-form-item form-group">
                            <i className="fa fa-angle-down"></i>
                            <select className="form-control seleccionable w-100"
                                onChange={(ev) => asignarMoneda(ev.target.value)}
                                value={MonedaSeleccionado}
                            >
                                <option value="">{t('comunes.seleccione', 'Seleccione')}</option>
                                {Object.values(Monedas).map((objeto, index) => (
                                    <option key={`curr-${index}`} value={objeto.ID}>
                                        {t(`backend.monedas.${objeto.Description.trim()}`, objeto.Description.trim())}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                    <div className="col-12 col-md-6 mb-3">
                        <h5 className="_c-dark"><span className="_c-p">*</span> {t('paso2.formaPago', 'Forma de pago original')} <span className="_c-p">{ErrorFormaPagoMsg}</span></h5>
                        <div className="theme-payment-page-form-item form-group">
                            <i className="fa fa-angle-down"></i>
                            <select className="form-control seleccionable w-100"
                                onChange={(ev) => asignarFormaPago(ev.target.value)} value={FormaPago}>
                                <option value="">{t('comunes.seleccione', 'Seleccione')}</option>
                                {Object.values(FormaDepago).map((objeto, index) => (
                                    <option key={`pay-${index}`} value={objeto.ID}>
                                        {t(`backend.formasPago.${objeto.Description.trim()}`, objeto.Description.trim())}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                    <div className="col-12 col-md-6 mb-3">
                        <h5 className="_c-dark"><span className="_c-p">*</span> {t('paso2.email', 'Email del solicitante')} <span className="_c-p">{ErrorEmailMsg}</span></h5>
                        <div className="theme-payment-page-form-item form-group">
                            <input
                                value={Correo}
                                onChange={(ev) => asignarCorreo(ev.target.value)}
                                className="form-control w-100"
                                type="email"
                                placeholder={t('paso2.placeholderEmail', 'solicitante@correo.com')}
                            />
                        </div>
                    </div>

                    {PoseeBoleto && (
                        <>
                            <div className="col-12 mt-3">
                                <div className="theme-page-section-header _ta-l">
                                    <h5 className="theme-page-section-title" style={{ fontSize: "28px" }}>{t('paso2.docPasajero', 'Documento del pasajero')}</h5>
                                    <h5 className="feature-subtitle _op-06">{t('paso2.subtituloDoc', 'Ingrese los datos del documento de identidad del pasajero.')}</h5>
                                    <hr className="style-3" />
                                </div>
                            </div>
                            <div className="col-12 col-md-4 mb-3">
                                <h5 className="_c-dark"><span className="_c-p">*</span> {t('paso2.paisDoc', 'País emisor del documento')}</h5>
                                <div className="theme-payment-page-form-item form-group">
                                    <i className="fa fa-angle-down"></i>
                                    <select className="form-control seleccionable w-100"
                                        onChange={(ev) => AsignarPaisOrigen(ev.target.value)}
                                        value={PaisOrigen}
                                    >
                                        <option value="">{t('comunes.seleccione', 'Seleccione')}</option>
                                        {Object.values(Paises).map((objeto, index) => (
                                            <option key={`country-${index}`} value={objeto.ID}>
                                                {t(`backend.paises.${objeto.Description.trim()}`, objeto.Description.trim())}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                            <div className="col-12 col-md-4 mb-3">
                                <h5 className="_c-dark"><span className="_c-p">*</span> {t('paso2.tipoDoc', 'Tipo de documento')}</h5>
                                <div className="theme-payment-page-form-item form-group">
                                    <i className="fa fa-angle-down"></i>
                                    <select className="form-control seleccionable w-100"
                                        onChange={(ev) => AsignarTipoDocumento(ev.target.value)}
                                        value={TipoDocumento}
                                    >
                                        <option value="">{t('comunes.seleccione', 'Seleccione')}</option>
                                        {Object.values(DocumentoPorPais).map((objeto, index) => (
                                            <option key={`typedoc-${index}`} value={objeto.ID}>
                                                {t(`backend.documentos.${objeto.Description.trim()}`, objeto.Description.trim())}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                            <div className="col-12 col-md-4 mb-3">
                                <h5 className="_c-dark"><span className="_c-p">*</span> {t('paso2.numeroDoc', 'Número de documento')}</h5>
                                <div className="theme-payment-page-form-item form-group">
                                    <input
                                        value={DocumentoReceptor}
                                        onChange={(ev) => asignarDocumentoReceptor(ev.target.value)}
                                        className="form-control w-100"
                                        type="text"
                                        placeholder={t('paso2.placeholderNumDoc', 'Doc. Identidad')}
                                    />
                                </div>
                            </div>
                        </>
                    )}
                </div>
            </div>
        </>
    );
}

export default Paso2;